import { transform } from 'lodash';

export const getExistingSiteIds = (sites) => {
    return transform(sites, (acc, site) => {
        const { siteID } = site;
        siteID > 0 && acc.push(siteID);
    }, []);
};

